/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
import SimpleButton from '@components/Buttons/SimpleButton';
import SectionTitle from '@components/Headings/SectionTitle';
import TopKolam from '@components/Headings/TopKolam';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */

/**
 * Returns the BenefitsGroup.
 * @param {Object} sectionContent - Content from API
 * @param {string} language - Language of the page
 * @param {string} region - Region of the page
 * @returns {ReactElement} Banner component
 */
const ProgramFee = ({ sectionContent, region, language, pageData }) => {
    // console.log("the sec in prgram fee", sectionContent)
    const pageName = pageData?.pageConfig?.pageName
    return (
        <Box
            // background="linear-gradient(180deg, #E4DED4 0%, #FFFBF1 90.99%, #FFF 100%)"
            marginTop="-35px"
            paddingTop={{ base: "110px", sm: "110px", md: "110px" }}
            paddingBottom={"60px"}
            background={"#E4DED4"}
        >
            <SectionTitle
                titleObj={sectionContent[0]}
                color="black"
                titleDecoration={sectionContent[0]?.titleDecoration}
                mx={{ base: '17px', md: 'auto' }}
                fontSize={{ base: "30px", sm: "30px", md: "" }}
            />
            <Box marginTop={"-30px"}>
                <TopKolam
                    sectionContent={sectionContent[1]}
                />
            </Box>
            <Box display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                flexDirection={{ "base": "column", "sm": "column", "md": "row" }}
                gap={"12px"}
            >
                <Box
                    w={{ base: "320px", sm: "320px", md: "365px" }}
                    background={"white"}
                    borderRadius={"6px"}
                    textAlign={"center"}
                    maxH={"111px"}
                >
                    <StructuredTextParser
                        sectionContent={sectionContent[2]}
                        str={render(sectionContent[2]?.body)}
                        textAlign={"center"}
                    />
                </Box>
                <Box
                    w={{ base: "320px", sm: "320px", md: "365px" }}
                    background={"white"}
                    borderRadius={"6px"}
                    textAlign={"center"}
                    maxH={"111px"}
                >
                    <StructuredTextParser
                        sectionContent={sectionContent[3]}
                        str={render(sectionContent[3]?.body)}
                        textAlign={"center"}
                    />
                </Box>
            </Box>
            <Box
                marginTop={"20px"}
            >
                <SimpleButton
                    style={sectionContent[4]}
                    region={region}
                    lang={language}
                    mx="auto"
                    width={"188px"}
                    pageConfig={pageData?.pageConfig}
                />
            </Box>
            <Box
                mx={"auto"}
                color={"#28231E"}
                textAlign={"center"}
                width={{ base: "", sm: "", md: "600px" }}
                fontSize={"16px"}
                fontStyle={"italic"}
                fontFamily={"FedraSansStd-book"}
            >
                <Box textAlign={"center"}
                    color={"#28231E"}
                    fontSize={"16px"}
                    lineHeight={{ base: '27px', md: '29px' }}>
                    {sectionContent[5]?.body?.value?.document?.children[0]?.children[0]?.value}
                </Box>
            </Box>


            <style>
                {`
               
                   #program-fee h4 {
                    color: #28231E;
                    text-align: center;
                    font-feature-settings: 'case' on;
                    font-family: "FedraSansStd-book";
                    font-size: 28px;
                    font-weight: bold;
                    line-height: 30px;
                    padding-bottom: 4px;
                    padding-top: 8px;
                }

                #program-fee p {
                    color: #6C6053;
font-feature-settings: 'case' on;
font-family: "FedraSansStd-book";
font-size: 18px;
font-weight: 400;
line-height: 30px;
padding-bottom: 24px;

                }
                `}

            </style>
        </Box >

    );
};

export default ProgramFee;
